/**
 * OpenAPI RxJS client throws ajax-shaped errors with numeric `status` for non-2xx responses.
 */
export const extractHttpStatusFromUnknown = (
  error: unknown,
): number | undefined => {
  if (error == null || typeof error !== "object") {
    return undefined;
  }
  const { status } = error as { status?: unknown };
  return typeof status === "number" && Number.isFinite(status)
    ? status
    : undefined;
};
